import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
import { Box } from "theme-ui"; // props: underline

export default React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: "button"
  }, props, {
    className: props.underline ? "animated-underline" : "",
    __themeKey: "buttons",
    __css: {
      color: function color(theme) {
        var _theme$buttons$root;

        return "".concat(((_theme$buttons$root = theme.buttons.root) === null || _theme$buttons$root === void 0 ? void 0 : _theme$buttons$root.color) || "#131313");
      },
      fontFamily: function fontFamily(theme) {
        var _theme$buttons$root2;

        return "".concat(((_theme$buttons$root2 = theme.buttons.root) === null || _theme$buttons$root2 === void 0 ? void 0 : _theme$buttons$root2.fontFamily) || theme.fonts.body);
      },
      textTransform: function textTransform(theme) {
        var _theme$buttons$root3;

        return "".concat(((_theme$buttons$root3 = theme.buttons.root) === null || _theme$buttons$root3 === void 0 ? void 0 : _theme$buttons$root3.textTransform) || "none");
      },
      fontSize: function fontSize(theme) {
        var _theme$buttons$root4;

        return "".concat(((_theme$buttons$root4 = theme.buttons.root) === null || _theme$buttons$root4 === void 0 ? void 0 : _theme$buttons$root4.fontSize) || "16px");
      },
      fontWeight: function fontWeight(theme) {
        var _theme$buttons$root5;

        return "".concat(((_theme$buttons$root5 = theme.buttons.root) === null || _theme$buttons$root5 === void 0 ? void 0 : _theme$buttons$root5.fontWeight) || "700");
      },
      letterSpacing: function letterSpacing(theme) {
        var _theme$buttons$root6;

        return "".concat(((_theme$buttons$root6 = theme.buttons.root) === null || _theme$buttons$root6 === void 0 ? void 0 : _theme$buttons$root6.letterSpacing) || "0.05em");
      },
      pt: "".concat(props.underline ? 3 : 4),
      pb: "".concat(props.underline ? 2 : 4),
      px: 7,
      borderRadius: function borderRadius(theme) {
        var _theme$buttons$root7;

        return "".concat(((_theme$buttons$root7 = theme.buttons.root) === null || _theme$buttons$root7 === void 0 ? void 0 : _theme$buttons$root7.borderRadius) || ".5em");
      },
      background: function background(theme) {
        var _theme$buttons$root8;

        return "".concat(((_theme$buttons$root8 = theme.buttons.root) === null || _theme$buttons$root8 === void 0 ? void 0 : _theme$buttons$root8.background) || theme.colors.primary);
      },
      border: 0,
      "& > span:after": {
        borderColor: function borderColor(theme) {
          var _theme$buttons$props$;

          return "".concat((_theme$buttons$props$ = theme.buttons[props.variant]) === null || _theme$buttons$props$ === void 0 ? void 0 : _theme$buttons$props$.underline);
        }
      },
      appearance: "none",
      outline: "0",
      cursor: "pointer",
      transform: "scale(1)",
      transition: function transition(theme) {
        var _theme$buttons$root9;

        return "".concat(((_theme$buttons$root9 = theme.buttons.root) === null || _theme$buttons$root9 === void 0 ? void 0 : _theme$buttons$root9.transition) || "box-shadow 250ms ease, background 250ms ease, background-color 250ms ease, transform 100ms ease");
      },
      minHeight: function minHeight(theme) {
        var _theme$buttons$root10;

        return "".concat(((_theme$buttons$root10 = theme.buttons.root) === null || _theme$buttons$root10 === void 0 ? void 0 : _theme$buttons$root10.minHeight) || "54px");
      },
      minWidth: function minWidth(theme) {
        var _theme$buttons$root11;

        return "".concat(((_theme$buttons$root11 = theme.buttons.root) === null || _theme$buttons$root11 === void 0 ? void 0 : _theme$buttons$root11.minWidth) || "224px");
      },
      "&:disabled": {
        color: "rgb(170, 170, 170)",
        backgroundColor: "rgb(221, 221, 221)",
        pointerEvents: "none"
      },
      "&:active": {
        color: function color(theme) {
          var _theme$buttons$props$2;

          return "".concat(((_theme$buttons$props$2 = theme.buttons[props.variant]) === null || _theme$buttons$props$2 === void 0 ? void 0 : _theme$buttons$props$2.activeColor) || "#fff");
        },
        // if gradient, unset else primary
        background: function background(theme) {
          var _theme$buttons$props$3;

          return "".concat(((_theme$buttons$props$3 = theme.buttons[props.variant]) === null || _theme$buttons$props$3 === void 0 ? void 0 : _theme$buttons$props$3.activeBgColor) || "");
        },
        transform: "scale(.95)",
        boxShadow: "none"
      }
    }
  }));
});